import { Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { maxMobile, routes } from "@configs";
import { ComponentAppRoute } from "@components";
import { IRoute } from "@interfaces";
import { Layout } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMobile } from "@redux";
import { useRouteGuard, useWindowDimensions } from "@utils";
import styled from "styled-components";

const AppRoutes = () => {
  useRouteGuard();

  return (
    <Switch>
      {routes.map((e: IRoute, key) => (
        <ComponentAppRoute key={key} {...e} layout={e.layout} />
      ))}
    </Switch>
  );
};

export const ModuleMain = () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    dispatch(setMobile(width <= maxMobile));
  }, [width]);

  return (
    <StyledWrapper>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </StyledWrapper>
  );
};

const StyledWrapper = styled(Layout)`
  min-height: 100vh;
`;
